export default __webpack_public_path__ + "static/media/loading.0763c950.svg";